/**
 * Social Sharing autohandler.
 *
 * Adding this auto handling here as a global attribute binding allows for
 * reusable component functionality across the entire site rather than
 * focused on a single page.
 *
 * Usage:
 *
 *  data-sw-social-share=<network>
 *
 * Example:
 *
 * <a href="http://url.to/open/when/clicked" data-sw-social-share="twitter">Click Me</a>
 */

var $ = require('./../sw-jquery');
var sw = require('js/lib/sw');
var popup = require('./../../lib/popup');
var modelShareIntentTrack = require('js/lib/tracking/model-share-intent');

$(document).ready(function() {
  
  $('body').on('click', '[data-sw-social-share]', function(e){
    var $this = $(this);
    e.preventDefault();
    popup({u: $this.attr('href')});
    
    var spin = $this.data('swSocialShareProductSpin');

    var modelId, location;

    if ($this.data('swSocialShareModelId')) {
      modelId = $this.data('swSocialShareModelId');
    }

    if ($this.data('swSocialShareLocation')) {
      location = $this.data('swSocialShareLocation');
    }

    else {
      location = 'productPage';
    }

    var data = {
      location: location,
      modelId: modelId,
      service: $this.data('swSocialShare'),
      rid: sw.data.rid
    };

    modelShareIntentTrack(sw.data.eventTracking.modelShareIntent, spin, $this.data('swSocialShare'), data);
  });

  $('body').on('click', '[data-sw-embed-share]', function(){
    var $this = $(this);
    if($this.data('swEmbedShareTracked')){
      return;
    }

    var spin = $this.data('swEmbedShareProductSpin');

    var modelId, location;

    if ($this.data('swEmbedShareModelId')) {
      modelId = $this.data('swEmbedShareModelId');
    }

    if ($this.data('swEmbedShareLocation')) {
      location = $this.data('swEmbedShareLocation');
    }

    else {
      location = 'productPage';
    }

    var data = {
      location: location,
      modelId: modelId,
      service: $this.data('swEmbedShare'),
      rid: sw.data.rid
    };

    modelShareIntentTrack(sw.data.eventTracking.modelShareIntent, spin, $this.data('swEmbedShare'), data);
    $this.data('swEmbedShareTracked', 'true');
  });
});
